const states = {
    // 通用配置
    config:{
        //数据刷新间隔
        refreshInterval:120000
    },

    //是否是移动端
    isMobile:false,
    //loading控制
    isLoading:false,
    //siderbar 控制
    siderbarOpen:true,
    //登陆用户信息
    userInfo:{
        token:"",//登陆用户token
        identity:"",//登陆用户身份权限
        role:"",//登陆用户角色权限
    },
    // 选中设备信息
    deviceInfo:{
    },
    // 跳转设备种类
    deviceListType:'',
    // 标准参数
    standTempData:[],
    // 播放器数据
    playerData:[]



};
export default states



// WEBPACK FOOTER //
// ./src/store/states.js